import { render } from "./ViewMediaFileMorePrams.vue?vue&type=template&id=49a276ea&scoped=true"
import script from "./ViewMediaFileMorePrams.vue?vue&type=script&lang=js"
export * from "./ViewMediaFileMorePrams.vue?vue&type=script&lang=js"

import "./ViewMediaFileMorePrams.vue?vue&type=style&index=0&id=49a276ea&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-49a276ea"

export default script